'use strict';

angular.module('schoolLinqApp').controller('balanceSheetController', [
	'$scope',
	'$rootScope',
	'$q',
	'$interval',
	'USER_CLAIMS',
	'unitService',
	'accountStructureService',
	'dialogHelper',
	'reportHelper',
	'BUSY_MESSAGE',
	function ($scope, $rootScope, $q, $interval, USER_CLAIMS, unitService, accountStructureService, dialogHelper, reportHelper, BUSY_MESSAGE) {
		var viewModel = getViewModel();
		$scope.vm = viewModel;

		if ($rootScope.mode && $rootScope.mode === 'nutrition') {
			$scope.vm.isNutrition = true;
			$scope.vm.fundMenuSection = 'NutritionReports';
			$scope.vm.sectiontitle = 'School Nutrition Balance Sheet';
		}

		$scope.reportInterval = null;
		$scope.isReportFinished = false;

		LoadFiscalYears($scope.vm);
		LoadFiscalMonths($scope.vm);

		$scope.loadingPromise = $q.all([LoadAccountStructures($scope.vm), LoadFunds($scope.vm)]);

		function getViewModel() {
			var model = {
				isNutrition: false,
				fundMenuSection: 'AccountsReports',
				sectiontitle: 'Balance Sheet',
				message: BUSY_MESSAGE.Loading,
				fiscalMonths: [],
				fiscalYears: [],
				elements: [],
				fundsCheckAll: true,
				fundsLeft: [],
				fundsMiddle: [],
				fundsRight: [],
				claimSections: USER_CLAIMS,
				filter: {
					fiscalYear: null,
					fiscalMonth: '0',
					thirteenthMonth: false,
					summarizeByFund: false,
					fundsSelected: [],
					reportParameters: [],
				},
				validationErrors: [],
				errors: null,
			};

			function validateReportParams(model) {
				model.validationErrors = [];
				let isValid = true;

				if (!model.filter.fiscalYear) {
					model.validationErrors.push('Please select a Fiscal Year.');
					isValid = false;
				}

				if (model.filter.thirteenthMonth !== true) {
					if (parseInt(model.filter.fiscalMonth) === 0) {
						model.validationErrors.push('Please select a valid Month or check 13 Month.');
						isValid = false;
					}
				}

				var isOneSelected = false;
				var arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
				angular.forEach(arrFunds, function (funds) {
					if (isOneSelected === false) {
						isOneSelected = _.some(funds, function (obj) {
							return obj.Selected === true;
						});
					}
				});

				if (isOneSelected === false) {
					model.validationErrors.push('Please select one or more Funds to include in Balance Sheet.');
					isValid = false;
				}

				return isValid;
			}

			function openReport(model) {
				if (!validateReportParams(model)) {
					dialogHelper.openMessageBox('Balance Sheet Report Error!', null, model.validationErrors, 'Warning');
					return false;
				}

				$scope.isReportFinished = false;
				model.message = BUSY_MESSAGE.GeneratingReport;
				$scope.loadingPromise = $scope.reportInterval = $interval(function () {
					if ($scope.isReportFinished) {
						$interval.cancel($scope.reportInterval);
						$scope.isReportFinished = false;
					}
				}, 1000);

				model.filter.reportParameters = [];

				//get selected funds
				model.filter.fundsSelected = [];
				if (model.fundsCheckAll === true) {
					model.filter.fundsSelected.push({ Id: 0, Description: 'All' });
				} else {
					var arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
					angular.forEach(arrFunds, function (funds) {
						angular.forEach(funds, function (obj) {
							if (obj.Selected === true) {
								var obj2 = { Id: obj.Id, Description: obj.Description };
								model.filter.fundsSelected.push(obj2);
							}
						});
					});
				}

				var report = {
					FiscalYear: model.filter.fiscalYear || 0,
					FiscalMonth: model.filter.fiscalMonth || 0,
					IsNutrition: model.isNutrition,
					ThirteenthMonth: model.filter.thirteenthMonth,
					SummarizeByFund: model.filter.summarizeByFund,
					FundsCol: model.filter.fundsSelected,
				};

				reportHelper.postReport($scope, '/api/fundreports/balancesheetreport', report, 'BalanceSheetReport.pdf');
			}

			function exportExcel(model) {
				if (!validateReportParams(model)) {
					dialogHelper.openMessageBox('Balance Sheet Report Error!', null, model.validationErrors);
					return false;
				}

				$scope.isReportFinished = false;
				model.message = BUSY_MESSAGE.GeneratingExcelFile;
				$scope.loadingPromise = $scope.reportInterval = $interval(function () {
					if ($scope.isReportFinished) {
						$interval.cancel($scope.reportInterval);
						$scope.isReportFinished = false;
					}
				}, 1000);

				model.filter.reportParameters = [];

				//get selected funds
				model.filter.fundsSelected = [];
				if (model.fundsCheckAll === true) {
					model.filter.fundsSelected.push({ Id: 0, Description: 'All' });
				} else {
					var arrFunds = [model.fundsLeft, model.fundsMiddle, model.fundsRight];
					angular.forEach(arrFunds, function (funds) {
						angular.forEach(funds, function (obj) {
							if (obj.Selected === true) {
								var obj2 = { Id: obj.Id, Description: obj.Description };
								model.filter.fundsSelected.push(obj2);
							}
						});
					});
				}

				var report = {
					FiscalYear: model.filter.fiscalYear || 0,
					FiscalMonth: model.filter.fiscalMonth || 0,
					IsNutrition: model.isNutrition,
					ThirteenthMonth: model.filter.thirteenthMonth,
					SummarizeByFund: model.filter.summarizeByFund,
					FundsCol: model.filter.fundsSelected,
				};

				reportHelper.postExcel($scope, '/api/fundreports/balancesheetexcel', report, 'BalanceSheet.xlsx');
			}

			function fundSelectChange(model) {
				var leftIsSelected = _.every(model.fundsLeft, function (obj) {
					return obj.Selected === true;
				});

				var middleIsSelected = _.every(model.fundsMiddle, function (obj) {
					return obj.Selected === true;
				});

				var rightIsSelected = _.every(model.fundsRight, function (obj) {
					return obj.Selected === true;
				});

				model.fundsCheckAll = leftIsSelected === true && middleIsSelected === true && rightIsSelected === true;
			}

			function fundCheckAllChange(model) {
				angular.forEach(model.fundsLeft, function (f) {
					f.Selected = model.fundsCheckAll;
				});

				angular.forEach(model.fundsMiddle, function (f) {
					f.Selected = model.fundsCheckAll;
				});

				angular.forEach(model.fundsRight, function (f) {
					f.Selected = model.fundsCheckAll;
				});
			}

			return angular.extend(model, {
				openReport: _.partial(openReport, model),
				exportExcel: _.partial(exportExcel, model),
				fundSelectChange: _.partial(fundSelectChange, model),
				fundCheckAllChange: _.partial(fundCheckAllChange, model),
			});
		}

		function LoadAccountStructures(model) {
			return accountStructureService.getStructure().then(_.partial(finishLoadingStructure, model));

			function finishLoadingStructure(model, response) {
				model.unifiedAccountMask = response.data.accountStructure.UnifiedAccountMask;
				model.unifiedFundElementIndex = response.data.accountStructure.UnifiedElementFundIndex;

				var arrElements = [];

				if (response.data.accountStructure.UnifiedElementMap !== null) {
					// model.elements = response.data.accountStructure.UnifiedElementMap.split('.');
					arrElements = response.data.accountStructure.UnifiedElementMap.split('.');
				} else {
					let assetElements = response.data.accountStructure.AssetElementMap.split('.');
					let liabilityElements = response.data.accountStructure.LiabilityElementMap.split('.');
					let reserveElements = response.data.accountStructure.ReserveElementMap.split('.');
					let revenueElements = response.data.accountStructure.RevenueElementMap.split('.');
					let expenseElements = response.data.accountStructure.ExpenseElementMap.split('.');

					//model.elements = _.union(assetElements, liabilityElements, reserveElements, revenueElements, expenseElements);
					arrElements = _.union(assetElements, liabilityElements, reserveElements, revenueElements, expenseElements);
				}

				//Build Elements
				angular.forEach(arrElements, function (e) {
					model.elements.push({ Id: e, Description: e });
				});
				model.elements.unshift({ Id: '-1', Description: '' });

				return angular.noop;
			}
		}

		function LoadFiscalYears(model) {
			$scope.loadingPromise = unitService.getFiscalYears().then(_.partial(finishLoadingYears, model));

			function finishLoadingYears(model, response) {
				model.fiscalYears = response.data.fiscalYears;
				model.filter.fiscalYear = response.data.currentFiscalYear;
				return angular.noop;
			}
		}

		function LoadFunds(model) {
			return accountStructureService.getFunds().then(_.partial(finishLoadingFunds, model));

			function finishLoadingFunds(model, response) {
				var arrFunds = response.data.funds;

				var colSize = 3;
				if (arrFunds.length === 0) {
					return angular.noop;
				} else {
					var partialCol = arrFunds.length % 3 > 0 ? 1 : 0;
					colSize = parseInt(arrFunds.length / 3) + partialCol;
				}

				angular.forEach(arrFunds, function (f) {
					var obj = { Id: f, Description: f, Selected: true };
					if (model.fundsLeft.length < colSize) {
						model.fundsLeft.push(obj);
					} else if (model.fundsMiddle.length < colSize) {
						model.fundsMiddle.push(obj);
					} else if (model.fundsRight.length < colSize) {
						model.fundsRight.push(obj);
					}
				});

				return angular.noop;
			}
		}

		function LoadFiscalMonths(model) {
			$scope.loadingPromise = unitService.getFiscalMonths().then(_.partial(finishLoadingMonths, model));

			function finishLoadingMonths(model, response) {
				var arrMonths = response.data.fiscalMonths;
				angular.forEach(arrMonths, function (m) {
					var obj = { Id: 0, Description: m };
					switch (m) {
						case 'January':
							obj.Id = 1;
							break;
						case 'February':
							obj.Id = 2;
							break;
						case 'March':
							obj.Id = 3;
							break;
						case 'April':
							obj.Id = 4;
							break;
						case 'May':
							obj.Id = 5;
							break;
						case 'June':
							obj.Id = 6;
							break;
						case 'July':
							obj.Id = 7;
							break;
						case 'August':
							obj.Id = 8;
							break;
						case 'September':
							obj.Id = 9;
							break;
						case 'October':
							obj.Id = 10;
							break;
						case 'November':
							obj.Id = 11;
							break;
						case 'December':
							obj.Id = 12;
							break;
					}
					model.fiscalMonths.push(obj);
				});
				model.fiscalMonths.unshift({ Id: '0', Description: '' });

				model.filter.fiscalMonth = parseInt(moment().format('MM'));

				return angular.noop;
			}
		}
	},
]);
